import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import './MemberUnavailable.css';
import Fade from 'react-reveal/Fade';
import ReactGA from 'react-ga';
import { setDigitalData } from '../../Utilities/Utils.js';

class DGRMemberUnavailable extends Component {

    componentDidMount(){
        this.props.DGRBackgroundStore.showBlurAndHeader()
        setDigitalData( 'member unavailable', this.props.DGRStore.club_number );
    }

    handleReturn = (e) => {
        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Member Option Unavailable',
            action: 'Return to Menu'
        });
        this.props.history.push( '/member/menu' );
    }

    productLabel() {
        return this.props.DGRStore.productLabels()[ this.props.DGRStore.club_product_id ];
    }

    unavailableMessage() {
        return (
            this.props.DGRStore.club_product_id === 'late_acceptance' ?
            'You do not have any unsigned agreements.' :
            'Please see a Front Desk Team Member to continue.'
        );
    }

    render(){
        return (
            <Fade>
                <div className="memberMenu memberUnavailable">

                    <div className="dgrTitleText">
                        <h2>{ this.productLabel() }</h2>
                    </div>

                    <div className="dgrTitleSubText">
                        <div className="subText">
                            { this.unavailableMessage() }
                        </div>
                    </div>

                    <div className="optionsBox">

                        <button className="sideButton" onClick={ this.handleReturn }>
                            <div>Return to Menu</div>
                        </button>

                    </div>
                </div>
            </Fade>
        )
    }
}

DGRMemberUnavailable = inject('DGRStore', 'DGRBackgroundStore','DGRProductStore' )(observer(DGRMemberUnavailable))
export default DGRMemberUnavailable



// WEBPACK FOOTER //
// ./src/components/DGR/MemberUnavailable/MemberUnavailable.js